// extracted by mini-css-extract-plugin
module.exports = {"buttons-container":"OrganizationForm_buttons-container__1Rvme","active-checkbox":"OrganizationForm_active-checkbox__3q6Dg","active":"OrganizationForm_active__2r9bM"};